import { render, staticRenderFns } from "./forgetPassword.vue?vue&type=template&id=86f30458&scoped=true"
import script from "./forgetPassword.vue?vue&type=script&lang=js"
export * from "./forgetPassword.vue?vue&type=script&lang=js"
import style0 from "./forgetPassword.vue?vue&type=style&index=0&id=86f30458&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f30458",
  null
  
)

export default component.exports